export default {
		'展位号': 'boothNo',
	'展位面积':'booth area',
	'参展商':'Exhibitor',
	'承建商群':'Business Cluster',
	'展位图纸':'Booth drawings',
		'展位信息确认': 'Booth Information Confirmation',
	'注：请核对展位相关信息（面积尺寸、高度限制、设计方案开口消防要求）务必确定无误方可开始报图。': 'Note: Please check the relevant information of the booth (area size, height limitation, fire control requirements for the opening of the design scheme) and make sure that it is correct before you can start to report the drawings.',
	'如有问题请先联系施工安全管理（联系方式见首页联系主场）': 'If you have any questions, please contact the construction safety management first (see home page for contact information)',
	'提示信息':'Tips',
	'当前展位已报图，但':'The current booth has been reported, but ',
	'请耐心等待审图结果':'Please wait patiently for the result of the map review.',
	'您可以在审图列表中修改申请或取消后重新申请':'You can modify the application in the drawing review list or reapply after cancellation.',
	'该展位已通过审图，请勿重复提交。':'This booth has passed the examination of maps, please do not submit it again.',
	'上一步':'Previous',
	'购买保险':'Buy insurance',
	'跳过':'skip',
	'下一步':'Next',
	'报图截止时间：': 'Report deadline:',
	'请在报图截止时间之前提交报图资料，若超过截止时间提交，每个过审展位都将收取延时审图费用，请您知悉！': 'Please submit the report materials before the deadline for submitting drawings. If you submit your files after the deadline, each booth will be charged a fee for delayed review. Please know!',
  '保险验证码不匹配':'Insurance verification code does not match, please enter the correct insurance verification code',
  '保险验证码不存在':'The system cannot find your insurance verification code, please contact the home court for details'
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsBoothConfirm.js